module.exports = __webpack_public_path__ + "static/media/gps_event_widget.620c5cf0.jpg";